/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

const OrderPackageStatuses = Object.freeze({
  DRAFT: '1',
  EPC_PENDING_ASSIGNMENT: '2',
  EPC_REVIEW: '3',
  RETURNED: '4',
  APPROVED: '5',
  AW_PACKAGED: '6',
  COMPLETE: '7',
  HIDDEN: '8',
  SUBMITTED_TO_VENDOR: '9',
  ARCHIVED: '10'
});

export default OrderPackageStatuses;
